import React from 'react';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import ShareButton from './ShareButton';
import FacebookIcon from '../Svg/FacebookIconFooter';
import PropTypes from 'prop-types';

const facebookClickAction = shareUrl => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareUrl
    )}`;
    window.open(url, 'popup', 'width=600,height=600');
    return true;
};

const FacebookShare = props => (
    <ShareButton
        handleClick={() =>
            facebookClickAction(props.shareUrl) && props.actionShared('facebook')
        }
    >
        <FacebookIcon />
    </ShareButton>
);

FacebookShare.propTypes = {
    shareUrl: PropTypes.string.isRequired,
    actionShared: PropTypes.func.isRequired
};

export default connect(
    state => ({
        shareUrl: state.widget.articleUrl
    }),
    {
        actionShared
    }
)(FacebookShare);



// WEBPACK FOOTER //
// ./src/components/SocialShareFooter/FacebookShare.jsx